import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"

export const getUsers = createAsyncThunk("get-users", async ({ pageIndex, numberOfRecords, orderBy, descending }) => {
    const response = await api.getGaiUsersByPagination({ pageIndex, numberOfRecords, orderBy, descending })
    return response
})

export const getUser = createAsyncThunk("get-user", async (id) => {
    return id
})

export const createUser = createAsyncThunk("create-user", async (payload) => {
    const response = await api.addGaiUser(payload)
    return response
})

export const inviteUser = createAsyncThunk("invite-user", async (id) => {
    const response = await api.inviteUser(id)
    return response
})

export const editUser = createAsyncThunk("edit-user", async (payload) => {
    const response = await api.editGaiUser(payload)
    return response
})

export const clearUser = createAsyncThunk("clear-user", async () => {
    return
})

export const deleteUser = createAsyncThunk("delete-user", async (id) => {
    const response = await api.deleteGaiUser(id)
    if (response.succeeded) {
        return id
    } else return null
})

const userSlice = createSlice({
    name: "user",
    initialState: {
        data: [],
        user: {},
        totalRecords: 0,
        fetchStatus: "",
        action: ""
    },
    reducers: {
        updateUser(state, action) {
            const { field, value } = action.payload
            state.user = { ...state.user, [field]: value }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsers.fulfilled, (state, action) => {
                state.data = action.payload?.records
                state.totalRecords = action.payload?.totalRecords
                state.fetchStatus = "success"
                state.action = "getUsers"
            })
            .addCase(getUsers.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getUsers"
            })
            .addCase(getUsers.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getUsers"
            })

            .addCase(getUser.fulfilled, (state, action) => {
                state.user = state.data.find((user) => user.id === action.payload)
                state.fetchStatus = "success"
                state.action = "getUser"
            })
            .addCase(getUser.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getUser"
            })
            .addCase(getUser.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getUser"
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "createUser"
            })
            .addCase(createUser.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "createUser"
            })
            .addCase(createUser.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "createUser"
            })
            .addCase(editUser.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "editUser"
            })
            .addCase(editUser.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "editUser"
            })
            .addCase(editUser.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "editUser"
            })

            .addCase(clearUser.fulfilled, (state, action) => {
                state.user = {}
                state.action = "clearUser"
            })
            .addCase(clearUser.pending, (state) => {
                state.action = "clearUser"
            })
            .addCase(clearUser.rejected, (state) => {
                state.action = "clearUser"
            })

            .addCase(deleteUser.fulfilled, (state, action) => {
                if (!!action.payload) {
                    const updatedData = state.data.map((row) => {
                        //DELETE API will disable the user only
                        if (row.id === action.payload) {
                            return {
                                ...row,
                                active: false
                            }
                        }
                        return row
                    })
                    state.data = [...updatedData]
                }
                state.fetchStatus = "success"
            })
            .addCase(deleteUser.pending, (state) => {
                state.fetchStatus = "loading"
            })
            .addCase(deleteUser.rejected, (state) => {
                state.fetchStatus = "error"
            })
            .addCase(inviteUser.fulfilled, (state, action) => {
                state.fetchStatus = "success"
            })
            .addCase(inviteUser.pending, (state) => {
                state.fetchStatus = "loading"
            })
            .addCase(inviteUser.rejected, (state) => {
                state.fetchStatus = "error"
            })
    }
})

export default userSlice

export const { name, actions, reducers } = userSlice
